import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface OrderUserListResponse {
  total: number;
  page: number;
  page_size: number;
  list: Users[];
};

export interface Users {
  id: string;
  order_no: string;
  user_name: string;
  email: string;
  user_id: string;
  agent_name: string;
  operator_id: number;
  operator_name: string;
  order_type: number;
  status: number;
  created_at: string;
  expire_at: string;
  description: string;
  order_attachment: string;
  order_attachment_name: string;
  order_attachment_type: string;
};

// 请求接口
interface OrderUserListResponseRequest {
  agentId: string,
  searchType: string | null, // email | user_name | user_id
  searchValue: string, // 针对searchType的模糊查询
  goodsId: string | null,
  page: number,
  pageSize: number
}

export class OrderUserData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Order no cannot be empty")
  @IsString("Order no must be a string")
  orderNo: string;
  
  @Required("Product name cannot be empty")
  @IsString("Product name must be a string")
  productName: string;

  @Required("User name cannot be empty")
  @IsString("User name must be a string")
  userName: string;

  @Required("Agent name cannot be empty")
  @IsString("Agent name must be a string")
  agentName: string;

  @Required("User id cannot be empty")
  @IsString("User id must be a string")
  userId: string;

  @Required("Operator id cannot be empty")
  @IsString("Operator id must be a string")
  operatorId: string;

  @Required("Operator name cannot be empty")
  @IsString("Operator name must be a string")
  operatorName: string;

  @Required("Order type cannot be empty")
  @IsNumber("Order type must be a number")
  orderType: number;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  @Required("Expire at cannot be empty")
  @IsString("Expire at must be a string")
  expireAt: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("Description cannot be empty")
  @IsString("Description must be a string")
  description: string;

  @IsString("Order attachment must be a string")
  orderAttachment: string;

  @IsString("Order attachment name must be a string")
  orderAttachmentName: string;

  @IsString("Order attachment type must be a string")
  orderAttachmentType: string;
}

export class OrderUserListData {
  @IsArray("List must be an array")
  list: OrderUserData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: OrderUserListResponse
): OrderUserListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, OrderUserListData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 订单用户列表 */
export const orderUserList = async ({
  page,
  pageSize,
  agentId,
  searchType,
  searchValue,
  goodsId,
}: OrderUserListResponseRequest): Promise<OrderUserListData> => {
  const response = await api.post<OrderUserListResponse>('/agent-v2/order-user-list', {
    page,
    page_size: pageSize,
    agent_id: agentId,
    search_type: searchType,
    search_value: searchValue,
    goods_id: goodsId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
